module.exports = __webpack_public_path__ + "static/media/strong12.13135ce8.jpg";